module.exports = __webpack_public_path__ + "static/media/SF-Compact-Text-Regular.aa3ef3b7.otf";